import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
export const getQueryString = (name, url) => {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  let r = (url || window.location.search.substr(1)).match(reg)
  if (r != null) {
    return unescape(r[2])
  }
  return null
}
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    list: [],
    buttonUrl: '',
    page: 1,
    count: 0,
    bottomButton: false,
    adUrl: '',
    apiPost: ''
  },
  mutations: {
    getList (state, list) {
      if (!state.list.length) {
        state.list = list
      } else {
        state.list = state.list.concat(...list)
      }
    },
    setButtonUrl (state, url) {
      state.buttonUrl = url
    },
    setPage: (state, v) => state.page = v,
    setCount: (state, v) => state.count = v,
    setBottomButton: (state, v) => state.bottomButton = v,
    setAdUrl: (state, v) => state.adUrl = v,
    setSplit: (state, v) => state.split = v,
    setApiPost: (state ,v) => state.apiPost = v
  },
  actions: {
    async report () {
      // const uid = getQueryString('uid')
      //const postId = getQueryString('postId')
      // console.log("uid:" + uid + "  postId:" + postId);
      // uid && await axios.get(`https://apidev.funnymamu.com/middlePage/report?${uid?'uid='+uid:''}${postId?'&p='+postId:''}`)
    },
    async getList ({ commit }, page) {
      const uid = getQueryString('uid')
      const postId = getQueryString('p')
      const res = await axios.get(`https://api.funnymamu.com/middlePage/message?pageSize=${10}&pageIndex=${page}${uid ? '&uid=' + uid : ''}${postId ? '&p=' + postId : ''}`)
      commit('getList', res.data.data.list)
      commit('setCount', res.data.data.totalCount)
      commit('setButtonUrl', res.data.data.buttonUrl)
      commit('setAdUrl', res.data.data.adUrl)
      commit('setSplit', res.data.data.split)
      commit('setApiPost',res.data.data.apiPost ? res.data.data.apiPost : '1')
    },
    setPage ({ commit }, val) {
      commit('setPage', val)
    },
    showBottomButton ({ commit }, val) {
      commit('setBottomButton', val)
    },
    setAdUrl ({ commit }, val) {
      commit('setBottomButton', val)
    }
  }
})
